module.exports = __webpack_public_path__ + "static/16gde-ab8e1131db9075bfdead37a67da5b676.gif";